var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-feed"},[_c('post-feed-grid',{attrs:{"posts":_vm.posts,"processing":_vm.processing}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }